

export const baseUrl = 'https://telran-backend.onrender.com';



export default baseUrl